/* PHA Black Friday price line (24 Oct 2026).
   Shows the reduced price on bf-deal products during the scheduled Shopify automatic discounts.
   The discount itself is applied by Shopify at checkout; this only displays it.
   Windows are UTC and must match the three scheduled discounts. ?bfdate=YYYY-MM-DD previews a date. */
(function () {
  var WINDOWS = [
    { pct: 10, start: '2026-11-08T14:00:00Z', end: '2026-11-15T14:00:00Z' },
    { pct: 15, start: '2026-11-15T14:00:00Z', end: '2026-11-22T14:00:00Z' },
    { pct: 20, start: '2026-11-22T14:00:00Z', end: '2026-11-30T14:00:00Z' }
  ];
  var now = new Date();
  var m = /[?&]bfdate=(\d{4}-\d{2}-\d{2})/.exec(location.search);
  if (m) now = new Date(m[1] + 'T12:00:00+10:00');
  var pct = 0;
  for (var i = 0; i < WINDOWS.length; i++) {
    if (now >= new Date(WINDOWS[i].start) && now < new Date(WINDOWS[i].end)) pct = WINDOWS[i].pct;
  }
  if (!pct) return;

  function off(cents) { return cents - Math.round(cents * pct / 100); }
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function run() {
    document.querySelectorAll('.price[data-bf-price]:not([data-bf-done])').forEach(function (el) {
      el.setAttribute('data-bf-done', '1');
      var c = parseInt(el.getAttribute('data-bf-price'), 10);
      if (!c) return;
      var card = el.getAttribute('data-bf-ctx') !== 'product';
      var from = el.getAttribute('data-bf-from') === '1';
      var box = document.createElement('div');
      box.className = 'pha-bf' + (card ? ' pha-bf--card' : '');
      box.innerHTML =
        '<div class="pha-bf__prices">' + (from ? '<span class="pha-bf__from">From </span>' : '') +
        '<s class="pha-bf__was">' + fmt(c) + '</s> <span class="pha-bf__now">' + fmt(off(c)) + '</span></div>' +
        '<div class="pha-bf__note">Black Friday: ' + pct + '% off' + (card ? '' : ', applied at checkout') + '</div>';
      el.classList.add('pha-bf-on');
      el.insertBefore(box, el.firstChild);
    });
    document.querySelectorAll('.pha-pack__each[data-bf-cents]:not([data-bf-done])').forEach(function (el) {
      el.setAttribute('data-bf-done', '1');
      var c = parseInt(el.getAttribute('data-bf-cents'), 10);
      if (!c) return;
      el.innerHTML = '<s class="pha-bf__was">' + fmt(c) + '</s> ' + fmt(off(c)) + ' each';
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 30); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();
